module.exports = __webpack_public_path__ + "static/img/wealth_level_78.5383414.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_78.png
// module id = vGix
// module chunks = 0